import * as React from 'react';
import { Section } from 'src/store/sections/types';
import { Link } from 'react-router-dom';
import { url } from 'src';
import { IconPaths } from 'src/icons';

interface Props {
  link: string;
  section: Section;
  style?: React.CSSProperties;
}
// to={`/section/${encodeURI(section.title).toLowerCase()}`}
const SectionComponent: React.SFC<Props> = ({ link, section, style }) => (
  <Link to={link} className="section-link animated fadeInUp" style={style}>
    <div className="section-item">
      {section.title === 'Erlebniscard' ? (
        <div
          className="title"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'left',
            flexDirection: 'row',
            flexWrap: 'wrap'
          }}
        >
          <div style={{ flexBasis: '100%' }} className="clearfix">
            <img src={IconPaths['ecard-logo']} title="Erlebniscard Logo" />
          </div>
          <h3>{section.title}</h3>
        </div>
      ) : (
        <div className="title">
          <h3>{section.title}</h3>
        </div>
      )}

      <div className="img">
        {section.image && section.image.url ? (
          <img
            src={url + section.image.url}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <img src="/gfx/erlebniscard-80.jpg" />
        )}
      </div>
    </div>
  </Link>
);

export default SectionComponent;



// WEBPACK FOOTER //
// ./src/components/Section/Section.tsx